import {Footer} from "@/components/layouts/main/Footer";
import {Header} from "@/components/layouts/main/Header";

import {useEffect} from "react";

import {BackButton} from "@ui/buttons/BackButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import {Logo} from "@ui/general/Logo";
import {H2} from "@ui/titles/H2";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useLocation} from "react-router-dom";

import styles from "./styles.module.scss";

export const Privacy = () => {
  const {t} = useTranslation();
  const {auth} = useSelector((state) => state.common.candidate);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({top: 0, behavior: "smooth"});
  }, [location]);

  return (
    <>
      <div className={"container-big"}>
        <div className={styles.privacyWrapper}>
          {auth ? (
            <Header />
          ) : (
            <div className={styles.privacyHead}>
              <Logo />
            </div>
          )}

          <BorderArticle>
            <div className={styles.privacy}>
              <BackButton />

              {t("page.policy.title_1") !== "" && (
                <div className={styles.privacyTitle}>
                  <H3>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("page.policy.title_1"),
                      }}
                    />
                  </H3>
                </div>
              )}

              {t("page.policy.title_2") !== "" && (
                <h1
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.title_2"),
                  }}
                />
              )}

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.last_upd"),
                  }}
                />
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.desc_1"),
                  }}
                />
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.desc_2"),
                  }}
                />
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.desc_3"),
                  }}
                />
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.desc_4"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.p_1"),
                  }}
                />
              </H2>

              <h4>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.p_1_1"),
                  }}
                />
              </h4>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.d_1_1"),
                  }}
                />

                <ul>
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_1_1_1"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_1_1_2"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_1_1_3"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_1_1_4"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_1_1_5"),
                    }}
                  />
                </ul>
              </RootDesc>

              <h4>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.p_1_2"),
                  }}
                />
              </h4>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.d_1_2"),
                  }}
                />

                <ul>
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_1_2_1"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_1_2_2"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_1_2_3"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_1_2_4"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_1_2_5"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_1_2_6"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_1_2_7"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_1_2_8"),
                    }}
                  />
                </ul>
              </RootDesc>

              <h4>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.p_1_3"),
                  }}
                />
              </h4>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.d_1_3"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.p_2"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.d_2"),
                  }}
                />

                <ul>
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_2_1"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_2_2"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_2_3"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_2_4"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_2_5"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_2_6"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_2_7"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_2_8"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_2_9"),
                    }}
                  />
                </ul>
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.p_3"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.d_3_1"),
                  }}
                />

                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.d_3_2"),
                  }}
                />

                <ul>
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_3_1"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_3_2"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_3_3"),
                    }}
                  />
                  {t("page.policy.l_3_4") !== "" && (
                    <li
                      dangerouslySetInnerHTML={{
                        __html: t("page.policy.l_3_4"),
                      }}
                    />
                  )}
                </ul>

                {t("page.policy.d_3_3") !== "" && (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.d_3_3"),
                    }}
                  />
                )}
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.p_4"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.d_4"),
                  }}
                />

                <ul>
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_4_1"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_4_2"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_4_3"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_4_4"),
                    }}
                  />
                </ul>
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.p_5"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.d_5"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.p_6"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.d_6"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.p_7"),
                  }}
                />
              </H2>

              <RootDesc>
                {t("page.policy.d_7") !== "" && (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.d_7"),
                    }}
                  />
                )}

                <ul>
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_7_1"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_7_2"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_7_3"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_7_4"),
                    }}
                  />
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t("page.policy.l_7_5"),
                    }}
                  />
                  {t("page.policy.l_7_6") !== "" && (
                    <li
                      dangerouslySetInnerHTML={{
                        __html: t("page.policy.l_7_6"),
                      }}
                    />
                  )}
                </ul>

                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.d_7_1"),
                  }}
                />
              </RootDesc>

              {t("page.policy.p_8") !== "" && (
                <>
                  <H2>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("page.policy.p_8"),
                      }}
                    />
                  </H2>

                  <RootDesc>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("page.policy.d_8"),
                      }}
                    />
                  </RootDesc>
                </>
              )}

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.p_9"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.d_9"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.p_10"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.d_10"),
                  }}
                />
              </RootDesc>

              <H2>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.p_11"),
                  }}
                />
              </H2>

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.policy.d_11"),
                  }}
                />
              </RootDesc>
            </div>
          </BorderArticle>
        </div>
      </div>

      <Footer />
    </>
  );
};
